import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class MossBrick extends DestroyableObstacle {
	static key = "MossBrick";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.ROCK_DEBRIS;
	}

	static deserialize(data: any): MossBrick {
		const m = new MossBrick(deserializeXY(data.xy));
		m.restoreBaseFields(data);
		return m;
	}
}
